import { useSelector } from "react-redux";
import {
    ArmazemGeralActions,
    INITIAL as ArmazemGeralState
} from "./armazemGeral";
import { EnumTiposLocal } from "../../../../utils/mxenumerados/tiposLocal";

/**
 * @typedef {Object} Volume
 * @property {boolean} novaEtiqueta
 * @property {string} id
 * @property {string} embalagemRegular
 * @property {string} embalagemMaster
 * @property {string} tipo
 * @property {string} quantidadeRegular
 * @property {string} contraMarca
 * @property {string} comprimento
 * @property {string} largura
 * @property {string} altura
 * @property {string} peso
 * @property {string} localId
 * @property {string} etiqueta
 * @property {EnumTiposLocal} tipoLocal
 *
 * @typedef {Object} Local
 * @property {string} localDeRemocao
 * @property {string} localDePosicionamento
 * @property {string} localId
 *
 * @typedef {Object} Remontagem
 * @property {Volume} origem
 * @property {Volume} destino
 * @property {string} remontagemId
 * @property {string} dataInicio
 * @property {string} dataFim
 * @property {string} ipaMarimex
 * @property {string} emp
 * @property {string} operacao
 * @property {string[]} state.mercadoriaOrigemImagem
 * @property {string[]} state.mercadoriaDestinoImagem
 * @property {string[]} state.origemAposRemontagemImagem
 * @property {string} tempoOperacao
 * @property {string} quantidadeAjudantes
 * @property {string} quantidadeOperadores
 *
 * @typedef {Object} Mercadoria
 * @property {string} id
 * @property {string} manifestado
 * @property {string} reconhecido
 * @property {string} remontado
 * @property {string} saldo
 * @property {string} saldoTotal
 * @property {string} descricao
 *
 * @typedef {Object} Materiais
 * @property {string} material
 * @property {string} quantidade
 *
 * @typedef {Object} Skill
 * @property {number} Id
 * @property {string} Descricao
 *
 * @typedef {Object} Skills
 * @property {string} Perfil
 * @property {Skill[]} Skills
 * @property {boolean} PodeDigitarEtiqueta
 * @property {boolean} PodeScannear
 * @property {number} ID
 * @property {boolean} Status
 * @property {string | null} ErrorMessage
 *
 *
 *
 * @typedef {Object} Embalagem
 * @property {string} codigo
 * @property {string} [abreviacao]
 * @property {string} Descricao
 *
 * @typedef {Object} Empilhadeira
 * @property {string} PrimeiraDescricao
 * @property {string} SegundaDescricao
 *
 * @typedef {Object} Localidade
 * @property {number} LocalId
 * @property {string} Local
 * @property {number} Tipo
 *
 * @typedef {Object} MaterialOperacional
 * @property {string} Codigo
 * @property {string} Descricao
 *
 * @typedef {Object} TipoStatusVolume
 * @property {string} Codigo
 * @property {string} Descricao
 *
 * @typedef {Object} Dominios
 * @property {Embalagem[]} EmbalagemMaster
 * @property {Embalagem[]} EmbalagemRegular
 * @property {Empilhadeira[]} Empilhadeira
 * @property {Localidade[]} Localidade
 * @property {MaterialOperacional[]} MaterialOperacional
 * @property {TipoStatusVolume[]} TipoStatusVolume
 */

/**
 * @description Hook para obter e modificar o estado do armazem geral
 * @typedef {Object} ArmazemGeral
 * @property {ArmazemGeralActions} actions
 * @property {Object} state
 * @property {Local} state.posicionamento
 * @property {Remontagem} state.remontagem
 * @property {Mercadoria[]} state.listaDeMercadoria
 * @property {Materiais[]} state.materiais
 * @property {Dominios} state.dominios TODO: Implementar tipagem desta propriedade, provavelmente string[]
 * @property {number} state.etapa
 * @property {string} state.quantidadeOperadores
 * @property {string} state.quantidadeAjudantes
 * @property {string} state.inicioOperacao
 * @property {string} state.fimOperacao

 * @property {Skills} state.skills
 *
 * @returns {ArmazemGeral} Objeto com o estado do armazem geral e as funções para modificar o estado
 */
export const useArmazemGeral = () => {
    // @ts-ignore
    const state = useSelector(state => state.armazemGeralReducer);
    return {
        actions: {
            ...ArmazemGeralActions
        },
        state
    };
};
